import React, { useEffect, useState } from "react";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DatePickerComponent = ({ handleDate, disabled, inputValue }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    handleDate(dateFormat(newDate));
  };

  useEffect(() => {
    if (inputValue !== "empty") {
      if (inputValue && !selectedDate) {
        const datevalue = parseDate(inputValue);

        const date = dayjs(
          `${datevalue.year}-${datevalue.month}-${datevalue.day}`,
        );
        setSelectedDate(date);
        // const date = dayjs(inputValue, "D.M.YYYY").toISOString();
        // setSelectedDate(inputValue !== "" ? date : null);
      }
    } else {
      setSelectedDate(null);
    }
  }, [inputValue]);

  useEffect(() => {
    if (disabled) {
      setSelectedDate(null);
    }
  }, [disabled]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        format={sessionStorage.getItem("df").toUpperCase()}
        value={selectedDate}
        onChange={handleDateChange}
        disabled={disabled}
      />
    </LocalizationProvider>
  );
};

export default DatePickerComponent;

function dateFormat(date) {
  const dateFormat = sessionStorage.getItem("df");
  const day = date.date();
  const month = date.month() + 1; // month is 0-indexed
  const year = date.year();

  switch (dateFormat.toUpperCase()) {
    case "DD.MM.YYYY":
      return `${day}.${month}.${year}`;
    case "MM.DD.YYYY":
      return `${month}.${day}.${year}`;
    case "YYYY.MM.dd":
      return `${year}.${month}.${day}`;
    case "DD/MM/YYYY":
      return `${day}/${month}/${year}`;
    case "MM/DD/YYYY":
      return `${month}/${day}/${year}`;
    default:
      return date.format("MM/DD/YYYY"); // fallback format
  }
}

export function parseDate(dateValue) {
  const parts = dateValue.match(/(\d+)/g);
  const format = sessionStorage.getItem("df").toUpperCase();
  let day, month, year;

  if (
    format === "DD.MM.YYYY" ||
    format === "DD/MM/YYYY" ||
    format === "DD-MM-YYYY"
  ) {
    day = parts[0];
    month = parts[1];
    year = parts[2];
  } else if (
    format === "MM.DD.YYYY" ||
    format === "MM/DD/YYYY" ||
    format === "MM-DD-YYYY"
  ) {
    month = parts[0];
    day = parts[1];
    year = parts[2];
  } else if (
    format === "YYYY.MM.DD" ||
    format === "YYYY/MM/DD" ||
    format === "YYYY-MM-DD"
  ) {
    year = parts[0];
    month = parts[1];
    day = parts[2];
  }

  return { day: day, month: month, year: year };
}
